import { useEffect, useRef, useState, useCallback } from "react";

import { Card } from "primereact/card";
import { FileUpload } from "primereact/fileupload";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";

import Menu from "../components/Menu";
import api from "../services/api";

export default function TesteQuebrasTrama() {
    const toast = useRef(null);

    const [dados, setDados] = useState([]);
    const [colunasHoras, setColunasHoras] = useState([]);
    const [loading, setLoading] = useState(false);

    const [limite, setLimite] = useState(5);
    const [intervalo, setIntervalo] = useState(1);
    const [dataPesquisa, setDataPesquisa] = useState(new Date());
    const [turno, setTurno] = useState(1);
    const [statusTurno, setStatusTurno] = useState('completo');

    const opcoesIntervalo = [
        { label: '1 em 1 hora', value: 1 },
        { label: '2 em 2 horas', value: 2 },
    ];

    const opcoesTurno = [
        { label: 'Turno 1 (06h às 18h)', value: 1 },
        { label: 'Turno 2 (18h às 06h)', value: 2 },
        { label: 'Dia Completo (24h)', value: 0 },
    ];

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error?.response?.data?.message || "Erro ao importar arquivo" });
    const showSuccess = (message) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: message });

    // Handler para o XML (Loomgate)
    const handleUploadFile = (event) => {
        const file = event.files[0];
        const formData = new FormData();
        formData.append("xml", file);

        setLoading(true);

        api.post("quebras-trama-loomgate", formData, {
            headers: { "Content-Type": "multipart/form-data" }
        })
        .then((response) => {
            handle(); 
            showSuccess(response.data.message);
        })
        .catch((error) => {
            showError(error);
        })
        .finally(() => { setLoading(false); });
    };

    const handleUploadCSV = (event) => {
        const file = event.files[0];
        const formData = new FormData();
        formData.append("csv", file);

        setLoading(true);

        api.post("quebras-trama-toyota", formData, {
            headers: { "Content-Type": "multipart/form-data" }
        })
        .then((response) => {
            handle(); 
            showSuccess(response.data.message);
        })
        .catch((error) => {
            showError(error);
        })
        .finally(() => { setLoading(false); });
    };

    const formatarDataBanco = (data) => {
        if (!data) return '';
        const d = new Date(data);
        const mes = `${d.getMonth() + 1}`.padStart(2, '0');
        const dia = `${d.getDate()}`.padStart(2, '0');
        const ano = d.getFullYear();
        return `${ano}-${mes}-${dia}`;
    };

    const handle = useCallback(() => {
        setLoading(true);

        api.get("teste", {
            params: {
                limite: limite,
                intervalo: intervalo,
                data_pesquisa: formatarDataBanco(dataPesquisa),
                turno: turno
            }
        })
        .then((response) => {
            setDados(response.data.quebra || []);
            setColunasHoras(response.data.horas || []);
            setStatusTurno(response.data.status_turno || 'completo');
        })
        .catch((error) => {
            console.error(error);
            toast.current.show({ summary: 'Erro', severity: 'error', detail: "Não foi possível carregar os dados." });
            setDados([]);
            setColunasHoras([]);
        })
        .finally(() => { setLoading(false); });
    }, [limite, intervalo, dataPesquisa, turno]);

    useEffect(() => {
        handle();
    }, [handle]);

    const cellTemplate = (rowData, hora) => {
        const valor = rowData[hora];
        const hasValue = valor !== undefined && valor !== null;

        return (
            <div 
                style={{ 
                    padding: '0.5rem', 
                    borderRadius: '4px',
                    backgroundColor: 'transparent',
                    color: 'inherit',
                    fontWeight: 'normal',
                    minHeight: '30px'
                }}
            >
                {hasValue ? valor : '--'}
            </div>
        );
    };

    const obterTextoStatusTurno = () => {
        if (statusTurno === 'nao_iniciado') 
            return <span className="p-ml-2" style={{color: '#973030',fontWeight: 'bold',fontSize: '0.85rem'}}>O turno ainda não iniciou!</span>;
        if (statusTurno === 'em_andamento') 
            return <span className="p-ml-2" style={{color: '#973030',fontWeight: 'bold',fontSize: '0.85rem'}}>O turno ainda está em andamento!</span>;
        return '';
    };

    return (
        <div>
            <Toast ref={toast} />
            <Menu />
            
            <Card 
                className="p-m-1"
                title={
                    <div className="p-d-flex p-ai-center p-jc-between">
                        <span>Monitoramento de Quebras de Trama</span>
                        
                        <div className="p-ml-auto p-d-flex" style={{ gap: '0.5rem' }}>
                            <FileUpload
                                mode="basic"
                                customUpload
                                auto
                                uploadHandler={handleUploadFile}
                                accept=".xml"
                                chooseLabel="XML Loomgate"
                                chooseOptions={{ icon: 'pi pi-upload', className: 'p-button-outlined p-button-secondary' }}
                            />
                            
                            <FileUpload
                                mode="basic"
                                customUpload
                                auto
                                uploadHandler={handleUploadCSV}
                                accept=".csv"
                                chooseLabel="CSV Toyota"
                                chooseOptions={{ icon: 'pi pi-file-excel', className: 'p-button-outlined p-button-success' }}
                            />
                        </div>
                    </div>
                }
                subTitle={
                    <div className="p-d-flex p-ai-center">
                        <span>{opcoesTurno.find(opcao => opcao.value === turno)?.label}</span>
                        {turno !== 0 && obterTextoStatusTurno()}
                    </div>
                }
            >                
                <nav className="p-d-flex p-flex-row p-grid p-ai-end p-mb-3">
                    <div className="p-m-1 p-col-12 p-md-2 p-fluid">
                        <label htmlFor="data" style={{ fontWeight: 'bold' }}>Data:</label>
                        <Calendar 
                            id="data" 
                            value={dataPesquisa} 
                            onChange={(e) => setDataPesquisa(e.value)} 
                            dateFormat="dd/mm/yy" 
                            mask="99/99/9999"
                            showIcon
                        />
                    </div>
                    
                    <div className="p-m-1 p-col-12 p-md-2 p-fluid">
                        <label htmlFor="limite" style={{ fontWeight: 'bold' }}>Acima de:</label>
                        <InputNumber 
                            inputId="limite" 
                            value={limite} 
                            onValueChange={(e) => setLimite(e.value)} 
                            mode="decimal" 
                            showButtons 
                            min={0} 
                        />
                    </div>

                    <div className="p-m-1 p-col-12 p-md-3 p-fluid">
                        <label htmlFor="turno" style={{ fontWeight: 'bold' }}>Turno:</label>
                        <Dropdown 
                            id="turno" 
                            value={turno} 
                            options={opcoesTurno} 
                            onChange={(e) => setTurno(e.value)} 
                        />
                    </div>

                    <div className="p-m-1 p-col-12 p-md-3 p-fluid">
                        <label htmlFor="intervalo" style={{ fontWeight: 'bold' }}>Agrupamento:</label>
                        <Dropdown 
                            id="intervalo" 
                            value={intervalo} 
                            options={opcoesIntervalo} 
                            onChange={(e) => setIntervalo(e.value)} 
                        />
                    </div>
                </nav>

                <section>
                    <DataTable
                        className="p-m-1"
                        value={dados}
                        paginator
                        rows={15}
                        loading={loading}
                        emptyMessage="Nenhum registro encontrado."
                        responsiveLayout="stack"
                        showGridlines
                        stripedRows
                    >
                        <Column field="machine" header="Tear" sortable style={{ minWidth: '100px', fontWeight: 'bold' }} />
                        <Column field="article" header="Artigo" sortable style={{ minWidth: '150px' }} />
                        
                        {colunasHoras.map((hora) => (
                            <Column 
                                key={hora} 
                                field={hora} 
                                header={hora} 
                                align="center"
                                body={(rowData) => cellTemplate(rowData, hora)} 
                                style={{ minWidth: '70px' }}
                            />
                        ))}
                    </DataTable>
                </section>
            </Card>
        </div>
    );
}